$(() => {
    const giftCertDiscount = new GiftCertDiscount();
    giftCertDiscount.setup();

    const paymentDiscounts = new PaymentDiscounts()
    paymentDiscounts.setup();
});


class Discounts {

    handleErrors(data, container, stateName) 
    {
        if (!data || !data) { showConnectionErrorMessage(); return true; }

        if(data.codeState !== 'valid') { 
            const errorMessage = new PaymentErrorMessage(container, stateName);
            errorMessage.showMessage(data.codeState)
            return true;
        }

        return false;
    }

}


class GiftCertDiscount extends Discounts {

    setup() {
       $('#gift-cert-code-input-row.form-error-message').hide();

        $('#check-gift-cert-button').on('click', () => {
            $('#gift-cert-code-input-row .form-error-message').hide();       
            this.onClick();
        });

        setupTextInputEnterSubmit($('.gift-cert-code-input'), $('#check-gift-cert-button'));
    }

    onClick() {
        this.checkCode();
    }

    checkCode() {

        const checkCodeUrl = baseUrl + '/check-gift-cert-code';
        const giftCertCode = $('.gift-cert-code-input').val();

        $.post(
            checkCodeUrl, 
            {'code': giftCertCode}, 
            (data) => {
                if(this.handleErrors(data, 'gift-cert', 'giftCertStates')) { return; }

                if($('#useGiftCertButton').length > 0) { this.useGiftCertWithoutSignup(); }
                else { this.showSignupForm(); }
            }
        );
    }

    useGiftCertWithoutSignup() {
        $('#useGiftCertButton').show();
        $('#useGiftCertButton').click();
        return;
    }

    showSignupForm() {

        $('#gift-cert-code-input-row').hide();
        $('#check-gift-cert-button').hide().on('click', () => {});
        $('.gift-cert-code-input').on('keydown', () => {});
                
        $('#after-code-validation').collapse();
    }

}

class PaymentDiscounts extends Discounts {

    setup() {
        $('#discount-info-link').on('click', (event) => {
            $('#discount-info-link').hide();
            $('#discount-info-container').fadeIn();
            $('#discount-info-input').focus();
        });
    
    
        $('#discount-info-submit').on('click', () => {
            const discountCode = $('#discount-info-input').val();
            this.checkDiscount(discountCode); 
        });
    
    
        setupTextInputEnterSubmit($('#discount-info-input'), $('#discount-info-submit'));
    }

    applyDiscount(discountCode, data) {
        $('#discount-code-input').val(discountCode);

        const paymentBlock = $('#paymentBlock');
        const currency = paymentBlock.data('currency');
        
        const basePrice = parseInt(paymentBlock.find('.price').attr('data-price'));
        const newPrice = Math.floor(basePrice - data.discount);

        paymentBlock.find('.price').css('text-decoration', 'line-through').css('color', '#3f3f41');
        paymentBlock.find('.discounted-price').text(formatCurrency(newPrice, currency)).fadeIn().css('color', '#5cad48');
    }

    checkDiscount(discountCode) {
        const checkCodeUrl = baseUrl + '/check-discount-code';

        const variant = $('.price-box.selected').data('variant');
        const amount = $('.amount-box.selected').length > 0 ? $('.amount-box.selected').data('amount') : 1;
    
        $.post(
            checkCodeUrl, 
            {
                'code': discountCode,
                'variant': variant,
                'amount': amount
            }, 
            (data) => {
                if(this.handleErrors(data, 'discount-code', 'discountCodeStates')) { return; }
    
                this.applyDiscount(discountCode, data);
                setCookie('payment-discount-code', discountCode, 5 * 60);
    
                $('#discount-info-container').hide();
                $('#discount-info-link').hide();
            }
        );
    }

}


